export default __webpack_public_path__ + "static/breakpoint-setting-do-dark-e24b71b569ed75a5ab81df19092d1787.png";